module.exports = __webpack_public_path__ + "img/head-side-cough-slash.f00b7d56.svg";